<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <div class="role-layout">
        <div class="data-container">
          <div class="top-tabs">
            <ElForm label-width="70" inline class="elementui-common-form-styles" v-highlight @submit.native.prevent>
              <ElFormItem label="权限配置">
                <el-input v-model="searchVal" clearable placeholder="请输入搜索角色" @change="search"></el-input>
              </ElFormItem>

              <ElFormItem class="bg-transparent">
                <el-button type="primary" @click="search">查询</el-button>
                <el-button class="addRole" @click="addUpdateRoleHandler('add')">添加角色</el-button>
              </ElFormItem>
            </ElForm>
          </div>
          <el-table
            ref="tableContainer"
            class="common-el-table-styles"
            :data="tableData"
            border
            height="calc(100vh - 208px)"
            style="width: 100%"
            v-loading="loading.queryTable"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="角色名称" prop="roleName" width="220" show-overflow-tooltip></el-table-column>
            <el-table-column label="授权人" prop="userList" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ authorities(scope.row) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="授权部门" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ setDept(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="addUpdateRoleHandler('update', scope.$index, scope.row)" type="text" size="small">
                  编辑
                </el-button>
                <el-button @click.native.prevent="deleteRole(scope.$index, scope.row)" type="text" size="small"> 删除 </el-button>
              </template>
            </el-table-column>
          </el-table>
          <Page
            v-if="tableData.length > 0"
            show-total
            show-sizer
            show-elevator
            :total="pager.total"
            :current.sync="pager.pageIndex"
            :page-size="pager.pageSize"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            class="c-table-page"
            size="small"
          />
        </div>

        <el-drawer
          custom-class="role-drawer"
          size="560px"
          :withHeader="false"
          :visible.sync="addUpdateDrawer"
          :destroy-on-close="true"
          @close="onFormDrawerClose"
        >
          <div class="drawer-body">
            <h4 v-if="selectedRow.roleId">编辑角色</h4>
            <h4 v-else>新增角色</h4>
            <divider>信息模块</divider>
            <el-form ref="role-form" :model="roleForm" label-width="80px" :rules="roleRules">
              <el-form-item label="角色名称" prop="roleName">
                <el-input v-model.trim="roleForm.roleName"></el-input>
              </el-form-item>
            </el-form>

            <divider>权限分配</divider>
            <!-- 功能权限选择框 -->
            <div id="transfer" class="clearfix">
              <div class="trans-left">
                <div class="tree-struct">
                  <slot name="leftSlot"></slot>
                  <el-tree
                    ref="leftTree"
                    :data="menuTreeData"
                    :props="{
                      children: 'childs',
                      label: 'name'
                    }"
                    node-key="id"
                    :expand-on-click-node="false"
                    style="font-size: 14px"
                    @node-click="handleNodeClick"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span :class="{ active: isActive(node, data) }">
                        {{ node.label }}
                      </span>
                    </span>
                  </el-tree>
                </div>
              </div>
              <div class="trans-right">
                <div class="selected-element">
                  <div v-if="selectedMenuTreeData.length" class="check-toggle">
                    <el-checkbox @change="toggleSelectedItems" v-model="roleForm.reverse"> 正选/反选 </el-checkbox>
                  </div>
                  <el-tree
                    ref="menuTree"
                    v-if="selectedMenuTreeData.length"
                    :data="selectedMenuTreeData"
                    show-checkbox
                    default-expand-all
                    node-key="id"
                    highlight-current
                    @check="checkChange"
                    :check-strictly="true"
                    :props="{ children: 'childs', label: 'name' }"
                  ></el-tree>
                </div>
              </div>
            </div>
          </div>
          <div class="drawer-footer">
            <el-button type="primary" :loading="loading.submit" @click="onSubmitForm"> 确定 </el-button>
            <el-button @click="addUpdateDrawer = false">取消</el-button>
          </div>
        </el-drawer>
      </div>
    </Content>
  </Layout>
</template>
<script>
import divider from './components/divider'
import { queryAllRoleByDept, deleteRole, addRole, updateRole, queryRoleAuth, queryMenuTreeByAuth } from '@/api/sysmana.model'
import { roleRules } from './components/rules.js'
import { deepClone } from './utils'

export default {
  components: {
    divider
  },
  data() {
    return {
      searchVal: '',
      loading: {
        queryTable: false,
        submit: false
      },
      pager: {
        total: 0,
        pageSize: 30,
        pageIndex: 1
      },
      allPermits: false,
      seletedUsersArray: [],
      seletedDeptsArray: [],
      showUserSelector: false,
      showDeptSelector: false,
      addUpdateDrawer: false,
      rawDataCateList: {},
      selectedMenuTreeData: [],
      tableData: [],
      tableHeight: 400,
      roleForm: {
        sync: false,
        synStatus: 0,
        roleType: 1
      },
      roleRules,
      deptId: '',
      leafNodes: [], // 勾选的叶子节点的授权码
      selectedRow: {},
      menuTreeData: [],
      checkStrictly: false,
      checkedArr: [],
      backCheckedArr: []
    }
  },
  computed: {
    isAdd() {
      return typeof this.selectedRow.roleId === 'undefined'
    }
  },
  watch: {
    selectedRow() {
      this.getMenuTree()
    }
  },
  created() {
    this.getMenuTree()
    this.getData()
  },
  methods: {
    getData() {
      this.loading.queryTable = true
      queryAllRoleByDept({
        deptId: '',
        name: this.searchVal,
        status: 1,
        roleType: 1,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      }).then((data) => {
        if (data) {
          this.tableData = data.list
          this.pager.total = data.page_info && data.page_info.total_number
          this.loading.queryTable = false
        }
      })
    },
    changePageIndex(index) {
      this.pager.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pager.pageSize = size
      this.getData()
    },
    getMenuTree() {
      queryMenuTreeByAuth().then((data) => {
        if (data) {
          this.menuTreeData = data.childs
        }
      })
    },
    // 查询
    search() {
      this.pager.pageIndex = 1
      this.getData()
    },
    // 保存角色
    onSubmitForm() {
      const roleFormRef = this.$refs['role-form']
      roleFormRef.validate((valid) => {
        if (valid) {
          // const { roleType } = this.roleForm
          const { userNameStr, departmentStr, sync, reverse, ...rest } = this.roleForm
          const checked = this.checkedArr.map((key) => 'M'.concat(key))
          const params = {
            userList: [],
            ...rest,
            roleDesc: this.roleForm.roleName,
            authorityCodes: this.checkedArr.length ? checked.concat('M' + this.menuTreeData[0].id) : []
          }

          this.loading.submit = true
          ;(this.isAdd ? addRole(params) : updateRole(params)).then((data) => {
            this.loading.submit = false
            // this.queryRolesByDept(this.deptId)
            this.getData()
            // this.$message.success(data.msg)
            roleFormRef.clearValidate()
            this.addUpdateDrawer = false
          })
        }
      })
    },
    async addUpdateRoleHandler(type, index, row) {
      if (type === 'add') {
        this.allPermits = false
      } else {
        this.selectedRow = deepClone(row)
        this.$set(this.roleForm, 'roleName', row.roleName)
        this.roleForm.roleId = row.roleId

        if (row.userList && row.userList.length) {
          this.roleForm.userList = row.userList
          this.$set(this.roleForm, 'userNameStr', row.userList.map((usr) => usr.name).join(','))
        }

        // 功能回显菜单权限
        this.backCheckedArr = []
        await queryRoleAuth({ roleId: row.roleId }).then((data) => {
          data.authorityCodes.forEach((code) => {
            this.backCheckedArr.push(code.slice(1))
          })
        })
      }

      this.addUpdateDrawer = true
    },
    deleteRole(idx, row) {
      this.$confirm('是否需要进行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRole({ roleId: row.roleId }).then((res) => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    checkChange(currentObj, checkStatus) {
      this.checkedArr = checkStatus.checkedKeys.concat(checkStatus.halfCheckedKeys)
    },

    // 正选反选当前选择菜单树
    toggleSelectedItems(v) {
      const checkedKeys = this.$refs.menuTree.getCheckedKeys()
      const menuTree = this.$refs.menuTree

      // 先清除已勾选的
      checkedKeys.forEach((id) => {
        menuTree.setChecked(id, false)
        // checkedMenuTreeKeys.delete(id)
      })
      // 遍历整个菜单树，勾选所有并排除上面被勾选的菜单
      this.checkedArr = []
      const checkLoop = (list) => {
        list.forEach((node) => {
          // 排除上面被勾选的菜单
          if (!checkedKeys.includes(node.id)) {
            menuTree.setChecked(node.id, true)
            this.checkedArr.push(node.id)
          }

          if (node.childs) {
            checkLoop(node.childs)
          }
        })
      }

      this.$nextTick(() => {
        checkLoop(this.selectedMenuTreeData)
      })
    },

    // 左侧菜单点击事件
    handleNodeClick(item) {
      // console.log(item)
      this.$set(this.roleForm, 'reverse', false)

      // 设置右侧菜单
      if (item.childs) {
        this.selectedMenuTreeData = item.childs
      }
      // 勾选右侧菜单已选中项
      this.$nextTick(() => {
        const menuTree = this.$refs.menuTree
        for (const key of this.backCheckedArr) {
          menuTree.setChecked(key, true)
        }
      })
    },

    isActive(node, data) {
      return this.backCheckedArr.includes(data.id)
    },
    authorities({ userList }) {
      return userList ? userList.map((i) => i.name).join(', ') : ''
    },
    setDept({ depts }) {
      return depts ? depts.map((d) => d.deptName).join(', ') : ''
    },

    // 页码
    handleCurrentChange(e) {
      console.log('e output: ', e)
    },
    // 关闭重置表单数据
    onFormDrawerClose() {
      // checkedMenuTreeKeys = new Set()
      this.checkedArr = []
      this.backCheckedArr = []
      this.leafNodes = []
      this.selectedRow = {}
      this.selectedMenuTreeData = []
      const { roleType } = this.roleForm
      this.roleForm = {
        sync: false,
        synStatus: 0,
        roleType
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-header {
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
}

::v-deep .role-drawer {
  .el-drawer__header {
    display: none;
  }
  .el-drawer__body {
    position: relative;
  }
  .drawer-body {
    padding: 20px;
    height: calc(100vh - 43px);
    overflow: auto;
    h4 {
      font-size: 16px;
    }
    .user-sync {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 10px;
        font-size: 13px;
        color: #94979e;
      }
    }
    .all-permits-flag {
      margin-bottom: 10px;
    }
  }
  .drawer-footer {
    padding: 5px 20px;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgb(248, 248, 248);
    border-top: 1px solid #ccc;
  }
}

.main-header {
  margin-bottom: 10px;
}
.top-tabs {
  padding-top: 10px;
  ::v-deep .role-tabs {
    width: 100%;
    .el-tabs__header {
      margin: 0;
      .el-tabs__nav-wrap {
        margin: 0;
      }
      .el-tabs__item {
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
::v-deep .el-table {
  margin-bottom: 10px;
}

#transfer {
  height: calc(100vh - 450px);
  h4 {
    margin-bottom: 15px;
  }

  ::v-deep .custom-tree-node {
    .active {
      color: #1890ff;
    }
  }
  .tree-struct,
  .selected-element {
    .check-toggle {
      margin-left: 18px;
    }
    border: 1px solid #d9e1e8;
    border-radius: 2px;
    li {
      font-size: 13px;
      color: #606266;
      cursor: pointer;
      position: relative;
      transition: background 0.3s;
      &:hover {
        background: #d9e1e8;
        i {
          opacity: 1;
        }
      }
      i {
        opacity: 0;
        position: absolute;
        right: 2px;
        top: 4px;
        transition: opacity 0.3s;
      }
      p {
        padding: 4px 6px;
      }
    }
  }
  .trans-left,
  .trans-right {
    position: relative;
    width: 48%;
    height: 100%;
    float: left;
    .tree-struct,
    .selected-element {
      // h4 height 34px
      // height: calc(100% - 34px);
      height: 100%;
      overflow: auto;
      padding: 12px;
    }
  }

  .trans-right {
    float: right;
  }
}

.c-table-page {
  margin: 10px 0 !important;
  padding: 0 8px;
  text-align: right;
}
</style>
